import browse from './browse.vue';
import form from './form.vue';
import read from './read.vue';
import roles from './roles';
import users from './users';

export default { browse, create: form, read, edit: form, roles, users };
